import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  List,
  IconButton
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { investorApi } from "../../api/api";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useSelector } from "react-redux";

const PropertyDocument = ({ data, userId, type }) => {
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const theme = useSelector((data) => data.themeValue.colors)
    const openPdf = (url) => {
    window.open(url, "_blank");
  };
  
  const payload = {
    userId,
    PropertyType: parseInt(type),
    ...(parseInt(type) === 1 && { projectId: data }),
    ...(parseInt(type) === 2 && { propertyId: data }),
    ...(parseInt(type) === 3 && { apartmentId: data }),
    ...(parseInt(type) === 4 && { propertyId: data }),
  };

  const fetchStatusAndDocuments = async () => {
    setLoading(true);
    try {
      const response = await investorApi.getPropertyDocumentStatus(payload);
      setRequestSubmitted(response.data.requestSubmitted);
      setDocuments(response.data.documents);
    } catch (error) {
      console.error("Error fetching document status", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatusAndDocuments();
  }, []);

 

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{...(type === 4 ? { mt: 5,mb:5 } : {mt:20, mb:5 }), ml: 2, backgroundColor: theme.background, borderRadius: 5, padding: 5 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom sx={{color:theme.text}}>
        Property Documents
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}>
          <CircularProgress size={24} />
          <Typography>Loading...</Typography>
        </Box>
      ) : documents.length > 0 ? (
        <List>
          {documents.map((doc, idx) => (
             <Box
              key={doc.id}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                mb: 1,
                borderRadius: 1,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfIcon color="error" />
                <Typography>{doc.DocumentName}</Typography>
              </Box>
              <Box>
                <IconButton onClick={() => openPdf(doc.DocumentURL)} aria-label="view" size="small">
                  <OpenInNewIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </List>
      ) : requestSubmitted ? (
        <Typography sx={{ mt: 2, color: "orange" }}>
          Request submitted. Waiting for admin to upload documents...
        </Typography>
      ) : (
  // ❗ Default fallback: no documents and no request submitted
  <Typography sx={{ mt: 2, color: "text.secondary" }}>
    No documents available.
  </Typography>
)}


      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
          Your request has been submitted.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PropertyDocument;
